export const processDemographicDataByPropForChart = (values, prop) => {
  const res = values ? Object.entries(values[prop]).sort((a, b) => b[1] - a[1]) : [];
  return res;
};

export const getValueByKeyContaining = (obj, substr) => {
  if (!obj) return null;
  const res = Object.entries(obj).find(x => x[0].indexOf(substr) !== -1);
  return res ? res[1] : null;
};

export const processInsightsOverviewDataForChart = metric => {
  const key = metric ? Object.keys(metric)[0] : [];
  const metricsWithProps = getValueByKeyContaining(metric, key);
  const values = getValueByKeyContaining(metricsWithProps, 'values');
  return values || [];
};

export const processInsightsOverviewData = data => {
  const viewsTotal = getValueByKeyContaining(data, 'pageViewsTotal');
  const impressionsUnique = getValueByKeyContaining(data, 'pageImpressionsUnique');
  const engagedUsers = getValueByKeyContaining(data, 'pagePostEngagements');
  const fanAddsByPaidNonPaidUnique = getValueByKeyContaining(
    data,
    'pageFanAddsByPaidNonPaidUnique',
  );

  const processedfanAddsPaidby = processInsightsOverviewDataForChart(fanAddsByPaidNonPaidUnique);

  const insightData = {
    pages_views: {
      name: 'page_views',
      title: 'Page Views',
      description:
        "The number of times a Page's profile has been viewed by logged in and logged out people.",
      values: processInsightsOverviewDataForChart(viewsTotal),
    },
    reach: {
      name: 'reach',
      title: 'Reach',
      description: 'The number of people who had any posts from your Page enter their screen.',
      values: processInsightsOverviewDataForChart(impressionsUnique),
    },
    post_engagements: {
      name: 'post_engagements',
      title: 'Post Engagements',
      description:
        'The number of times people have engaged with your posts through likes, comments and shares and more.',
      values: processInsightsOverviewDataForChart(engagedUsers),
    },
    page_likes: {
      name: 'page_likes',
      title: 'Page Likes',
      description: 'The number of people who have liked your page',
      values: processedfanAddsPaidby.map(x => ({ ...x, value: x.value.total })),
    },
  };

  return insightData;
};

export const processDemographicData = data => {
  // const genderAge = getValueByKeyContaining(data, 'gender');
  const city = getValueByKeyContaining(data, 'city');
  const country = getValueByKeyContaining(data, 'country');
  const locale = getValueByKeyContaining(data, 'locale');

  return {
    // gender: processDemographicDataByPropForChart(genderAge, 'gender'),
    // age: processDemographicDataByPropForChart(genderAge, 'age'),
    city: processDemographicDataByPropForChart(city, 'value'),
    country: processDemographicDataByPropForChart(country, 'value'),
    locale: processDemographicDataByPropForChart(locale, 'value'),
  };
};



// WEBPACK FOOTER //
// ./src/components/social/SocialDashboardUtils.js